export const SET_SEARCH_USER = 'SET_SEARCH_USER';
export const CLEAR_SEARCH_USER = 'CLEAR_SEARCH_USER';
